export enum ExternalUrl {
  MiningContact = 'https://www.wabteccorp.com/digital-intelligence/digital-mine#contact',
  PrivacyPolicy = 'https://www.wabteccorp.com/privacy-policy',
}

export enum Permalink {
  ProductDocumentation = '/api/permalink/core-productdocumentation',
  KnowledgeBase = '/api/permalink/core-knowledgebase',
  SupportRequest = '/api/permalink/core-supportrequest',
  SubmitFeedback = '/api/permalink/core-submitideas',
}
